/**
 * Shared helpers for the Asset Management FE (ADR-0024 Phase 4). Mirrors
 * expenseShared.tsx.
 */
import type { DerivedAssetStatus, AssignmentStatus } from '../api/assets.js';

/** assignedAt=null means UNKNOWN — never today's date, never a placeholder date. */
export function fmtAssignedAt(iso: string | null): string {
  if (!iso) return 'date unknown';
  return new Date(iso).toLocaleDateString();
}
export function fmtDate(iso: string | null): string {
  return iso ? new Date(iso).toLocaleDateString() : '—';
}

const ASSET_STATUS_CLASS: Record<DerivedAssetStatus, string> = {
  available: 'border-green-900 bg-green-950/40 text-green-300',
  assigned: 'border-blue-900 bg-blue-950/40 text-blue-300',
  retired: 'border-gray-700 bg-gray-900 text-gray-400',
  lost: 'border-red-900 bg-red-950/40 text-red-300',
};
export function AssetStatusBadge({ status }: { status: DerivedAssetStatus }): JSX.Element {
  return <span className={`inline-block rounded border px-2 py-0.5 text-xs ${ASSET_STATUS_CLASS[status]}`}>{status}</span>;
}

const ASN_STATUS_CLASS: Record<AssignmentStatus, string> = {
  requested: 'border-yellow-900 bg-yellow-950/40 text-yellow-300',
  approved: 'border-blue-900 bg-blue-950/40 text-blue-300',
  issued: 'border-green-900 bg-green-950/40 text-green-300',
  returned: 'border-gray-700 bg-gray-900 text-gray-400',
  rejected: 'border-red-900 bg-red-950/40 text-red-300',
  cancelled: 'border-gray-700 bg-gray-900 text-gray-500',
};
export function AssignmentStatusBadge({ status }: { status: AssignmentStatus }): JSX.Element {
  return <span className={`inline-block rounded border px-2 py-0.5 text-xs ${ASN_STATUS_CLASS[status]}`}>{status}</span>;
}

export function TabButton({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }): JSX.Element {
  return (
    <button type="button" onClick={onClick} className={`rounded px-3 py-1.5 text-sm ${active ? 'bg-white text-black' : 'border border-gray-700 text-gray-300 hover:bg-gray-900'}`}>
      {children}
    </button>
  );
}
